// @flow

import React from 'react';
import { Form } from 'semantic-ui-react';
import { nullOrEmpty } from './index';
import type { PluginProps } from '../QuestionContent';

const TextContent = ({
  content,
  showValidationErrors,
  onChange,
}: PluginProps) => {
  const changePlaceholder = event => {
    const value = event.target.value;

    onChange({
      ...content,
      placeholder: value,
      isValid: value.length > 0,
      hasChanged: value.length > 0,
    });
  };

  return (
    <Form.Field
      required
      error={showValidationErrors && nullOrEmpty(content.placeholder)}
    >
      <label>Texte indicatif</label>
      <input
        type="text"
        placeholder="Saisissez un texte indicatif"
        value={content.placeholder || ''}
        onChange={changePlaceholder}
      />
    </Form.Field>
  );
};

export default TextContent;



// WEBPACK FOOTER //
// ./src/modules/survey/components/questions/contents/TextContent.js